module.exports = __webpack_public_path__ + "static/media/tuer_loesung.d8815d3e.jpg";